'use client';

import React, { useMemo } from 'react';
import useVelocityAccountStore from 'src/stores/useVelocityAccountsStore';
import useUserAccountIsReady from 'src/hooks/useUserAccountIsReady';
import { cj } from 'src/utils/classNames';
import MarginCalcPanel from 'src/components/MarginInfo/MarginCalcPanel';
import { MOBILE_TABLE_CARD_LIST_CLASSNAME } from 'src/components/Tables/cards/consts';

const MobileAndTabletAccountHealth = React.memo(
	function MobileAndTabletAccountHealth() {
		const userClient = useVelocityAccountStore(
			(s) => s.accounts[s.currentUserKey ?? '']?.client
		);
		const isUserAccountReady = useUserAccountIsReady();

		// Get marginCalc to check for isolated positions
		const marginCalc = useMemo(() => {
			return userClient && isUserAccountReady
				? userClient.getMarginCalculation('Maintenance')
				: undefined;
		}, [userClient, isUserAccountReady]);

		// Check if isolated positions exist
		const hasIsolatedPositions = useMemo(() => {
			if (!marginCalc) return false;
			return marginCalc.isolatedMarginCalculations.size > 0;
		}, [marginCalc]);

		return (
			<div className="h-full">
				<div
					className={cj(
						MOBILE_TABLE_CARD_LIST_CLASSNAME,
						'flex h-full flex-col items-stretch justify-between text-text-default',
						'sm:py-2'
					)}
				>
					<MarginCalcPanel
						filteredMarginCalcs="cross"
						className="w-full sm:pt-0"
						includeDetailsAndDepositButtons={true}
					/>

					{hasIsolatedPositions && (
						<MarginCalcPanel
							filteredMarginCalcs="isolated"
							className="w-full sm:pt-0"
						/>
					)}
				</div>
			</div>
		);
	}
);

export { MobileAndTabletAccountHealth };
